/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CmsService {
    /**
     * List articles
     * Returns a paginated list of articles with optional filters
     * @param organizer Organizer slug
     * @param limit Number of items to return (default 20, max 100)
     * @param offset Offset for pagination (default 0)
     * @param status Filter by status: draft, published
     * @param type Filter by article type
     * @param eventId Filter by event ID
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsArticles(
        organizer: string,
        limit?: number,
        offset?: number,
        status?: string,
        type?: string,
        eventId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/articles',
            path: {
                'organizer': organizer,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'status': status,
                'type': type,
                'event_id': eventId,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create article
     * Creates a new article
     * @param organizer Organizer slug
     * @param body Article data
     * @returns any Created
     * @throws ApiError
     */
    public static postOrganizersCmsArticles(
        organizer: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/articles',
            path: {
                'organizer': organizer,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get article by ID
     * Returns a single article by UUID
     * @param organizer Organizer slug
     * @param id Article ID (UUID)
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsArticles1(
        organizer: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/articles/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update article
     * Updates an existing article
     * @param organizer Organizer slug
     * @param id Article ID (UUID)
     * @param body Article data
     * @returns any OK
     * @throws ApiError
     */
    public static putOrganizersCmsArticles(
        organizer: string,
        id: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/cms/articles/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete article
     * Deletes an article
     * @param organizer Organizer slug
     * @param id Article ID (UUID)
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersCmsArticles(
        organizer: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/cms/articles/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Publish article
     * Publishes an article (changes status to published)
     * @param organizer Organizer slug
     * @param id Article ID (UUID)
     * @param body Publish options (publish_date timestamp)
     * @returns any OK
     * @throws ApiError
     */
    public static postOrganizersCmsArticlesPublish(
        organizer: string,
        id: string,
        body?: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/articles/{id}/publish',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Unpublish article
     * Unpublishes an article (changes status to draft)
     * @param organizer Organizer slug
     * @param id Article ID (UUID)
     * @returns any OK
     * @throws ApiError
     */
    public static postOrganizersCmsArticlesUnpublish(
        organizer: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/articles/{id}/unpublish',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List collections
     * Returns all collections for an organizer
     * @param organizer Organizer slug
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsCollections(
        organizer: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/collections',
            path: {
                'organizer': organizer,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new collection
     * Creates a new collection
     * @param organizer Organizer slug
     * @param body Collection data
     * @returns any Created
     * @throws ApiError
     */
    public static postOrganizersCmsCollections(
        organizer: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/collections',
            path: {
                'organizer': organizer,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a single collection
     * Retrieves a specific collection by ID
     * @param organizer Organizer slug
     * @param id Collection ID (UUID)
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsCollections1(
        organizer: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/collections/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a collection
     * Updates an existing collection
     * @param organizer Organizer slug
     * @param id Collection ID (UUID)
     * @param body Collection update data
     * @returns any OK
     * @throws ApiError
     */
    public static putOrganizersCmsCollections(
        organizer: string,
        id: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/cms/collections/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a collection
     * Deletes a collection by ID
     * @param organizer Organizer slug
     * @param id Collection ID (UUID)
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersCmsCollections(
        organizer: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/cms/collections/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List collection children
     * Returns child collections of a parent
     * @param organizer Organizer slug
     * @param id Parent Collection ID (UUID)
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsCollectionsChildren(
        organizer: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/collections/{id}/children',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List collection media
     * Returns media items in a collection
     * @param organizer Organizer slug
     * @param id Collection ID (UUID)
     * @param limit Number of items to return (default 20, max 100)
     * @param offset Offset for pagination (default 0)
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsCollectionsMedia(
        organizer: string,
        id: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/collections/{id}/media',
            path: {
                'organizer': organizer,
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Add media to collection
     * Adds a media item to a collection
     * @param organizer Organizer slug
     * @param id Collection ID (UUID)
     * @param body Media data
     * @returns any OK
     * @throws ApiError
     */
    public static postOrganizersCmsCollectionsMedia(
        organizer: string,
        id: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/collections/{id}/media',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Remove media from collection
     * Removes a media item from a collection
     * @param organizer Organizer slug
     * @param id Collection ID (UUID)
     * @param mediaId Media ID (UUID)
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersCmsCollectionsMedia(
        organizer: string,
        id: string,
        mediaId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/cms/collections/{id}/media/{mediaId}',
            path: {
                'organizer': organizer,
                'id': id,
                'mediaId': mediaId,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List images
     * Returns a paginated list of images
     * @param organizer Organizer slug
     * @param limit Number of items to return (default 20, max 100)
     * @param offset Offset for pagination (default 0)
     * @param search Search by filename or alt text
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsImages(
        organizer: string,
        limit?: number,
        offset?: number,
        search?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/images',
            path: {
                'organizer': organizer,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new image
     * Creates a new image record
     * @param organizer Organizer slug
     * @param body Image data
     * @returns any Created
     * @throws ApiError
     */
    public static postOrganizersCmsImages(
        organizer: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/images',
            path: {
                'organizer': organizer,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload an image
     * Uploads an image file, processes it, and stores it in S3
     * @param organizer Organizer slug
     * @param file Image file to upload
     * @param altText Alt text for the image
     * @param collectionId Collection ID to add image to
     * @returns any Created
     * @throws ApiError
     */
    public static postOrganizersCmsImagesUpload(
        organizer: string,
        file: Blob,
        altText?: string,
        collectionId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/images/upload',
            path: {
                'organizer': organizer,
            },
            formData: {
                'file': file,
                'alt_text': altText,
                'collection_id': collectionId,
            },
            errors: {
                400: `Bad Request`,
                413: `Request Entity Too Large`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a single image
     * Retrieves a specific image by ID
     * @param organizer Organizer slug
     * @param id Image ID (UUID)
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsImages1(
        organizer: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/images/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an image
     * Updates an existing image
     * @param organizer Organizer slug
     * @param id Image ID (UUID)
     * @param body Image update data
     * @returns any OK
     * @throws ApiError
     */
    public static putOrganizersCmsImages(
        organizer: string,
        id: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/cms/images/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete an image
     * Deletes an image by ID
     * @param organizer Organizer slug
     * @param id Image ID (UUID)
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersCmsImages(
        organizer: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/cms/images/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List pages
     * Returns a paginated list of static pages with optional filters
     * @param organizer Organizer slug
     * @param limit Number of items to return (default 20, max 100)
     * @param offset Offset for pagination (default 0)
     * @param status Filter by status: draft, published
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsPages(
        organizer: string,
        limit?: number,
        offset?: number,
        status?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/pages',
            path: {
                'organizer': organizer,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'status': status,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new page
     * Creates a new static page
     * @param organizer Organizer slug
     * @param body Page data
     * @returns any Created
     * @throws ApiError
     */
    public static postOrganizersCmsPages(
        organizer: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/pages',
            path: {
                'organizer': organizer,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get page by ID
     * Returns a single page by UUID
     * @param organizer Organizer slug
     * @param id Page ID (UUID)
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsPages1(
        organizer: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/pages/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a page
     * Updates an existing static page
     * @param organizer Organizer slug
     * @param id Page ID (UUID)
     * @param body Page update data
     * @returns any OK
     * @throws ApiError
     */
    public static putOrganizersCmsPages(
        organizer: string,
        id: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/cms/pages/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a page
     * Deletes a static page by ID
     * @param organizer Organizer slug
     * @param id Page ID (UUID)
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersCmsPages(
        organizer: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/cms/pages/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Publish a page
     * Changes a page status to published
     * @param organizer Organizer slug
     * @param id Page ID (UUID)
     * @param body Publish options (publish_at)
     * @returns any OK
     * @throws ApiError
     */
    public static postOrganizersCmsPagesPublish(
        organizer: string,
        id: string,
        body?: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/pages/{id}/publish',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Unpublish a page
     * Changes a page status to draft
     * @param organizer Organizer slug
     * @param id Page ID (UUID)
     * @returns any OK
     * @throws ApiError
     */
    public static postOrganizersCmsPagesUnpublish(
        organizer: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/pages/{id}/unpublish',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List tags
     * Returns a paginated list of tags
     * @param organizer Organizer slug
     * @param limit Number of items to return (default 20, max 100)
     * @param offset Offset for pagination (default 0)
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsTags(
        organizer: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/tags',
            path: {
                'organizer': organizer,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new tag
     * Creates a new tag
     * @param organizer Organizer slug
     * @param body Tag data
     * @returns any Created
     * @throws ApiError
     */
    public static postOrganizersCmsTags(
        organizer: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/cms/tags',
            path: {
                'organizer': organizer,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get tag hierarchy
     * Returns tag hierarchy tree for an organizer
     * @param organizer Organizer slug
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsTagsHierarchy(
        organizer: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/tags/hierarchy',
            path: {
                'organizer': organizer,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get tag by slug
     * Returns a single tag by slug
     * @param organizer Organizer slug
     * @param slug Tag slug
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsTagsSlug(
        organizer: string,
        slug: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/tags/slug/{slug}',
            path: {
                'organizer': organizer,
                'slug': slug,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get tag by ID
     * Returns a single tag by UUID
     * @param organizer Organizer slug
     * @param id Tag ID (UUID)
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsTags1(
        organizer: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/tags/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a tag
     * Updates an existing tag
     * @param organizer Organizer slug
     * @param id Tag ID (UUID)
     * @param body Tag update data
     * @returns any OK
     * @throws ApiError
     */
    public static putOrganizersCmsTags(
        organizer: string,
        id: string,
        body: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/cms/tags/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a tag
     * Deletes a tag by ID
     * @param organizer Organizer slug
     * @param id Tag ID (UUID)
     * @returns void
     * @throws ApiError
     */
    public static deleteOrganizersCmsTags(
        organizer: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/organizers/{organizer}/cms/tags/{id}',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get tag children
     * Returns child tags of a parent tag
     * @param organizer Organizer slug
     * @param id Parent Tag ID (UUID)
     * @returns any OK
     * @throws ApiError
     */
    public static getOrganizersCmsTagsChildren(
        organizer: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/cms/tags/{id}/children',
            path: {
                'organizer': organizer,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
}
